export const COMMON = "COMMON"
